module.exports = __webpack_public_path__ + "static/media/RP-70.ac5ca327.pdf";